import React from "react"
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { elementTypeListInTable } from "../../entities/Constants";
import { Panel } from "primereact/panel";
import { DialogforTableMoreButton } from "./DialogforTableMoreButton";
import { ConfirmDialog } from 'primereact/confirmdialog';

interface Props {
  ele: FormSectionElements;
  isEng: boolean;
  callback;
}

interface State {
  downdropDialogVisible: boolean[];
  tableDialogVisible: boolean[];
  dateDialogVisible: boolean[];
  checkboxDialogVisible: boolean[];
  tableMoreButtonDialogVisible: boolean[];
  showConfirmationDialog: boolean;
  deleteColumnIndex: number;
}

export class TableComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      downdropDialogVisible: [],
      tableDialogVisible: [],
      dateDialogVisible: [],
      checkboxDialogVisible: [],
      tableMoreButtonDialogVisible: [],
      showConfirmationDialog: false,
      deleteColumnIndex: -1,
    }
  }

  tableHtml = () => {
    let ele = this.props.ele;
    let htmlString = [];
    ele.LoadBindBase = ele.ENUTitle?.replace(/\s/g, "");
    let listHtml = [];
    let totalElementHtml = [];
    if (ele.subSectionList == null) {
      ele.subSectionList = [];
      let subSection = new FormSubSections();
      subSection.parent = ele;
      ele.subSectionList.push(subSection);
    }

    let subSection = ele.subSectionList[0];

    if (subSection.ListOfFormSectionElements == null) {
      subSection.ListOfFormSectionElements = [];
    }
    if (subSection.ListOfFormSectionElements.length === 0) {
      let eleTable = new FormSectionElements();
      eleTable.Sequence = subSection.ListOfFormSectionElements.length + 1;
      eleTable.parent = subSection;
      eleTable.Editable = "Y";
      subSection.ListOfFormSectionElements.push(eleTable);
    }

    subSection.ListOfFormSectionElements.forEach((ele, index) => {
      let eleHtml = (
        <div style={{ marginTop: "5px" }} >
          <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", paddingTop: "10px", alignContent: "center" }}>
            <div style={{ width: "2%", paddingRight: "5px", paddingTop: "7px" }}>
              {ele.Sequence}
            </div>
            <div style={{ width: "25%", paddingRight: "5px" }}>
              <InputText
                className="ontario-input"
                placeholder="Column header"
                value={(this.props.isEng? ele.ENUTitle: ele.FRATitle) ?? ''}
                onChange={(e) => {
                  this.props.isEng ? (ele.ENUTitle = e.target.value) : (ele.FRATitle = e.target.value);
                  ele.LoadBindName = this.props.isEng? ele.ENUTitle: ele.FRATitle;
                  ele.parent = subSection;
                  this.props.callback();
                }}
              />
            </div>

            <div style={{ width: "20%", paddingLeft: "5px" }} key={`dropdown_table_${ele.ENUTitle}`}>
              {/* @ts-ignore */}
              <Dropdown
                optionLabel="label"
                optionValue="val"
                options={elementTypeListInTable}
                value={ele.Datatype}
                onChange={(e) => {
                  ele.Datatype = e.value;
                  if (e.value === "Dropdown") {
                    this.state.downdropDialogVisible[ele.Sequence - 1] = true;
                    this.setState({ downdropDialogVisible: this.state.downdropDialogVisible });
                  }
                  if (e.value === "Date") {
                    this.state.dateDialogVisible[ele.Sequence - 1] = true;
                    this.setState({ dateDialogVisible: this.state.dateDialogVisible });
                  }
                  this.props.callback();
                }}
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-start", width: "25%", paddingLeft: "5px", paddingTop: "4px", textAlign: "center" }} key={`txt_table_field_${ele.Id}`}>
              <div style={{ paddingTop: "8px" }}>
                <label htmlFor={`txt_Field_${ele.ENUTitle}`} />&nbsp;Field&nbsp;
              </div>
              <div>
                <InputText className="ontario-input" 
                  id={`txt_Field_${ele.ENUTitle}`} 
                  value={(this.props.isEng? ele.LoadBindName : ele.FRATitle) ?? ''} 
                  onChange={(e) => { ele.LoadBindName = e.target.value; this.props.callback(); }} 
                />
              </div>
            </div>

            <div style={{ marginLeft: "20px", marginTop: "10px", width: "10%" }} key={`moreOptions_${ele.Id}`}>
              <i
                title="More Options"
                className="pi pi-ellipsis-v"
                style={{ fontSize: "1rem", cursor: "pointer" }}
                onClick={(e) => {
                  this.state.tableMoreButtonDialogVisible[ele.Sequence - 1] = true;
                  this.setState({ tableMoreButtonDialogVisible: this.state.tableMoreButtonDialogVisible });
                }}
              />
            </div>

            <div style={{ marginLeft: "20px", marginTop: "10px", width: "10%" }} key={`delete_table_colum_${ele.Id}`}>
              <i
                title="Remove me"
                className="pi pi-trash"
                style={{ fontSize: "1rem", cursor: "pointer" }}
                onClick={() => {
                  this.setState({ showConfirmationDialog: true, deleteColumnIndex: index });
                }}
              />
            </div>
          </div>
        </div>
      )

      totalElementHtml.push(
        <div style={{ display: this.props.ele.Editable !== "Y" ? "block" : "none" }}>
          <DialogforTableMoreButton ele={ele} dialogVisible={this.state.tableMoreButtonDialogVisible[ele.Sequence - 1]} isEng={this.props.isEng} callback={(visible) => {
            if (visible != null) {
              this.state.tableMoreButtonDialogVisible[ele.Sequence - 1] = false;
              this.setState({ tableMoreButtonDialogVisible: this.state.tableMoreButtonDialogVisible });
            }
            this.props.callback();
          }} />
        </div>
      )

      if (ele.Datatype === "Date") {
        totalElementHtml.push(
          <div style={{ display: this.props.ele.Editable !== "Y" ? "block" : "none" }} >
            <DialogforTableMoreButton ele={ele} dialogVisible={this.state.dateDialogVisible[ele.Sequence - 1]} isEng={this.props.isEng} callback={(visible) => {
              if (visible != null) {
                this.state.dateDialogVisible[ele.Sequence - 1] = false;
                this.setState({ dateDialogVisible: this.state.dateDialogVisible });
              }
              this.props.callback();
            }} />
          </div>
        )
      }

      if (ele.Datatype === "Dropdown") {
        totalElementHtml.push(
          <div style={{ display: this.props.ele.Editable !== "Y" ? "block" : "none" }} >
            <DialogforTableMoreButton ele={ele} dialogVisible={this.state.downdropDialogVisible[ele.Sequence - 1]} isEng={this.props.isEng} callback={(visible) => {
              if (visible != null) {
                this.state.downdropDialogVisible[ele.Sequence - 1] = false;
                this.setState({ downdropDialogVisible: this.state.downdropDialogVisible });
              }
              this.props.callback();
            }} />
          </div>
        )
      }

      if (ele.Datatype === "Checkbox") {
        totalElementHtml.push(
          <div style={{ display: this.props.ele.Editable !== "Y" ? "block" : "none" }} >
            <DialogforTableMoreButton ele={ele} dialogVisible={this.state.checkboxDialogVisible[ele.Sequence - 1]} isEng={this.props.isEng} callback={(visible) => {
              if (visible != null) {
                this.state.checkboxDialogVisible[ele.Sequence - 1] = false;
                this.setState({ checkboxDialogVisible: this.state.checkboxDialogVisible });
              }
              this.props.callback();
            }} />
          </div>
        )
      }
      totalElementHtml.push(eleHtml);
    })

    listHtml.push(<>
      {/* @ts-ignore */}
      <Panel toggleable header="Table Columns" style={{ marginTop: "5px" }} key={`list_element_${ele.Sequence.toString()}`}>
        <div>{totalElementHtml}</div>
      </Panel></>
    )

    listHtml.push(
      <div>
        <i
          style={{ border: "1px solid grey", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", marginTop: "10px" }}
          className="pi pi-plus"
          onClick={(e) => {
            let eleTable = new FormSectionElements();
            eleTable.Sequence = subSection.ListOfFormSectionElements.length + 1;
            eleTable.parent = subSection;
            eleTable.Editable = "Y";
            subSection.Id = eleTable.Sequence.toString();
            subSection.ListOfFormSectionElements.push(eleTable);
            this.props.callback();
          }}
        />
      </div>
    )

    htmlString.push(listHtml);

    return htmlString;
  }

  handleConfirmation = (confirmed: boolean) => {
    if (confirmed) {
      const { deleteColumnIndex } = this.state;
      if (deleteColumnIndex !== -1) {
        const subSection = this.props.ele.subSectionList[0];
        subSection.ListOfFormSectionElements.splice(deleteColumnIndex, 1);
        this.props.callback();
      }
    }

    this.setState({ showConfirmationDialog: false, deleteColumnIndex: -1 });
  }

  render() {
    return (
      <>
        {this.tableHtml()}
        {/* @ts-ignore */}
        <ConfirmDialog
          visible={this.state.showConfirmationDialog}
          message="Are you sure you want to remove this element?"
          header="Confirmation"
          rejectLabel="No"
          acceptLabel="Yes"
          icon="pi pi-exclamation-triangle"
          accept={() => this.handleConfirmation(true)}
          reject={() => this.handleConfirmation(false)}
          closable={false}
        />
      </>
    )
  }
}
